import { Box } from '@mui/material';

import styled from 'styled-components';

export const StyledOfferingTableContainer = styled(Box)`
  .MuiTableRow-root {
    &:not(.MuiTableRow-head) .MuiTableCell-root {
      --vPadding: ${({ theme }) => theme.spacing(4)};

      padding-top: var(--vPadding);
      padding-bottom: var(--vPadding);
    }

    .MuiTableCell-root:first-of-type {
      padding-left: ${({ theme }) => theme.spacing(2.5)};
    }

    &:hover {
      cursor: pointer;
    }
  }

  .MuiTableHead-root {
    .MuiTableCell-root {
      --vPadding: ${({ theme }) => theme.spacing(2)};

      padding-top: var(--vPadding);
      padding-bottom: var(--vPadding);

      border-bottom-width: 0;
    }

    .MuiButtonBase-root {
      flex-direction: row;
    }
  }
`;
